import { GET_PAYMENT_EMAIL } from '../../constants/actions/payment';

export function getPaymentEmail() {
    return {
        type: GET_PAYMENT_EMAIL,
    };
}
